// Copyright 2017-2021 @polkadot/apps authors & contributors
// SPDX-License-Identifier: Apache-2.0
// @ts-nocheck
import { unzlibSync, zlibSync } from 'fflate';
import queryString from 'query-string';

import { settings } from '@polkadot/ui-settings';
import { assert, stringToU8a, u8aToString } from '@polkadot/util';
import { base64Decode, base64Encode } from '@polkadot/util-crypto';

export function decodeUrlTypes() {
  // eslint-disable-next-line no-restricted-globals
  const urlOptions = queryString.parse(location.href.split('?')[1]);

  if (urlOptions.types) {
    try {
      assert(
        !Array.isArray(urlOptions.types),
        'Expected a single type specification',
      );

      const parts = urlOptions.types.split('#');
      const compressed = base64Decode(decodeURIComponent(parts[0]));
      const uncompressed = unzlibSync(compressed);

      return JSON.parse(u8aToString(uncompressed));
    } catch (error) {
      console.error(error);
    }
  }

  return null;
}

export function encodeUrlTypes(types) {
  const jsonU8a = stringToU8a(JSON.stringify(types));
  const compressed = zlibSync(jsonU8a, { level: 9 });
  const encoded = base64Encode(compressed);

  return `${window.location.origin}${
    window.location.pathname
  }?rpc=${encodeURIComponent(settings.apiUrl)}&types=${encodeURIComponent(
    encoded,
  )}`;
}

export function transform(api, { value }) {
  return function (method) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return api.query[value.creator.section]
      ? api.query[value.creator.section][method]
      : value;
  };
}

export function transform2(api, section) {
  return function (method) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return api.query[section]
      ? api.query[section][method]
      : api.query.system.events;
  };
}
